import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import store from "./store";
import Swal from 'sweetalert2';
import VueLoading from 'vue-loading-overlay';
import VueHtmlToPaper from 'vue-html-to-paper';
import 'vue-loading-overlay/dist/vue-loading.css';
import Popover from 'vue-js-popover'

import LayoutHeader from '@/components/layouts/Header'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/plugins/fontawesome/css/fontawesome.min.css'
import '../static/datetimepicker/bootstrap-datetimepicker.min.css'
import './assets/plugins/fontawesome/css/all.min.css'
import './assets/css/animate.min.css'
import './assets/css/admin.css'
import MySidebar from "./components/layouts/MySidebar";
import {allowedModules} from "./utils/modules";
import {messages} from "./utils/messages";
import Decimal from 'decimal.js';
import Vue2Editor from "vue2-editor"

let Bootstrap = require('bootstrap')

Decimal.set({rounding: Decimal.ROUND_HALF_UP});

window.Swal = Swal;
Vue.config.productionTip = false

Vue.use(VueLoading);

Vue.use(Popover, {tooltip: true})

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(Vue2Editor)
Vue.use(VueHtmlToPaper, options);
Vue.use(VueI18n)

Vue.component('layout-header', LayoutHeader)
Vue.component('layout-sidebar', MySidebar)

const CURRENT_VERSION = '1.0.0';
if (localStorage.getItem('appVersion') !== CURRENT_VERSION) {
  localStorage.setItem('appVersion', CURRENT_VERSION);
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
  window.location.reload(true);
}

// Import domain branding to get locale
import { getLocaleByDomain } from './config/domainBranding'

// Get locale based on current domain
const activeLocale = getLocaleByDomain(location.host)

const i18n = new VueI18n({
  locale: activeLocale,
  fallbackLocale: "commerce",
  messages
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js